// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"8c85960a","317":"f92fedb6","511":"6fea36fe"}[chunkId] + ".chunk.js";
};